import LiquorTree from 'liquor-tree'
// @ts-ignore
import contextMenu from 'vue-context-menu'
import { Component, Mixins, Prop, Ref, Watch } from 'vue-property-decorator'
import IncidentFormModal from '@/components/incidentsModal/IncidentFormModal.vue'
import PriorityDot from '@/modules/clinicalModule/components/StatusRequestPriorityDot.vue'
import AddFileModal from '@/components/AddFileModal.vue'
import CommonPortionStatusBadge from '@/components/common/CommonPortionStatusBadge.vue'
import VtBubble from '@/components/common/VtBubble.vue'
import CommonSampleStatusBadge from '@/components/common/CommonSampleStatusBadge.vue'
import cancellationReasonServices from '@/api/resources/common/cancellation-reason-services/cancellationReasonServices'
import ItemsForShippingModal from '@/modules/shipments-module/old/views/components/ItemsForShippingModal.vue'
import IncidentCard from '@/components/IncidentCard.vue'
import RequestDownloadableAttachment from '@/modules/clinicalModule/components/RequestDownloadableAttachment.vue'
import DownloadableAttachment from '@/components/common/downloadable-attachment/downloadable-attachment.vue'
import AssaysViewModalToolbarSummary from '@/components/assays-view/components/modal-toolbar-summary/assays-view-modal-toolbar-summary.vue'
import AssaysViewBatchModalAssaysComponent from '@/components/assays-view/components/batch/batch-modal-assays/assays-view-batch-modal-assays.vue'
import AssaysViewBatchModalAssays from '@/components/assays-view/components/batch/batch-modal-assays/assays-view-batch-modal-assays'
import AssaysViewBatchModalProtocolsComponent from '@/components/assays-view/components/batch/batch-modal-protocols/assays-view-batch-modal-protocols.vue'
import AssaysViewBatchModalProtocols from '@/components/assays-view/components/batch/batch-modal-protocols/assays-view-batch-modal-protocols'
import { SampleOperationGuardMixin } from '@/api/operations/mixins/guards/sample-operation-guard.mixin'
import { PortionOperationGuardMixin } from '@/api/operations/mixins/guards/portion-operation-guard.mixin'
import { SubportionOperationGuardMixin } from '@/api/operations/mixins/guards/subportion-operation-guard.mixin'
import { IncidentOperationGuardMixin } from '@/api/operations/mixins/guards/incident-operation-guard.mixin'
import { ShipmentOperationGuardMixin } from '@/api/operations/mixins/guards/shipment-operation-guard.mixin'
import { ASSAY_STATES, assayState } from '@/api/resources/entityState/assay-state'
import { SUBPORTION_STATES } from '@/api/resources/entityState/subportion-state'
import incidentServices from '@/api/resources/incident/incidentServices'
import { commonDeviceService } from '@/api/services/common/device/common-device.service'
import { SubportionOperation } from '@/api/operations/models/subportion-operation'
import { CommonPriorityResponse } from '@/api/services/common/priority/common-priority.dto'
import { commonPortionTypeService } from '@/api/services/common/portion-type/common-portion-type.service'
import { PortionTypeEnum } from '@/api/services/common/portion-type/common-portion-type.dto'
import { PORTION_TYPES } from '@/api/resources/portionTypeService'
import { CommonDeviceParams, CommonDeviceResponse } from '@/api/services/common/device/common-device.dto'
import { BModal } from 'bootstrap-vue'
import apiExceptionType from '@/utils/apiExceptionType'
import { Nullable } from '@/shared/types/app.types'
import { Dictionary, groupBy, intersection, sortBy, uniq, uniqBy } from 'lodash'
import {
    AssaysViewModalState,
    AssaysViewNode,
    AssaysViewTypeEnum,
    AttachmentEntityType,
    IncidentEntityIdHierarchy,
    IncidentEntityType,
    initialAssaysViewModalState,
    LabeledEntity
} from '@/components/assays-view/components/modal/assays-view-modal.model'
import { AssayModalAssayWithValuableConceptResponse } from '@/components/assays-view/services/assays-view-assay/assays-view-assay.dto'
import sessionStore from '@/session/sessionStore'
import { StoreUtils } from '@/shared/util/store-utils'
import {
    AssaysViewPortionResponse,
    AssaysViewPortionsCancelRequest,
    HierarchicalPortionTreeRequest,
    HierarchicalSampleTreeRequest
} from '@/components/assays-view/services/assays-view-portion/assays-view-portion.dto'
import {
    AssaysViewApplyAssaysRequest,
    AssaysViewSubportionResponse,
    AssaysViewSubportionsCancelRequest,
    HierarchicalSubportionTreeRequest
} from '@/components/assays-view/services/assays-view-subportion/assays-view-subportion.dto'
import { assaysViewPortionService } from '@/components/assays-view/services/assays-view-portion/assays-view-portion.service'
import { assaysViewSubportionService } from '@/components/assays-view/services/assays-view-subportion/assays-view-subportion.service'
import { AssaysViewSampleResponse } from '@/components/assays-view/services/assays-view-case/assays-view-case.dto'
import { assaysViewCaseService } from '@/components/assays-view/services/assays-view-case/assays-view-case.service'
import { assaysViewAssayService } from '@/components/assays-view/services/assays-view-assay/assays-view-assay.service'
import ModalConfirmationCheckable from '@/components/modals/ModalConfirmationCheckable.vue'
import { EnumResponse } from '@/api/services/common.dto'
import { ModuleOperationGuard } from '@/api/operations/guards/module-operation-guard'
import { UserType } from '@/api/resources/common/initialization/common-initialization.dto'

@Component({
    components: {
        LiquorTree,
        contextMenu,
        AssaysViewBatchModalProtocolsComponent,
        AssaysViewBatchModalAssaysComponent,
        AddFileModal,
        IncidentFormModal,
        ItemsForShippingModal,
        PriorityDot,
        VtBubble,
        CommonSampleStatusBadge,
        CommonPortionStatusBadge,
        AssaysViewModalToolbarSummary,
        IncidentCard,
        RequestDownloadableAttachment,
        DownloadableAttachment,
        ModalConfirmationCheckable
    }
})
export default class AssaysViewModal
    extends Mixins(
        SampleOperationGuardMixin,
        PortionOperationGuardMixin,
        SubportionOperationGuardMixin,
        IncidentOperationGuardMixin,
        ShipmentOperationGuardMixin
    ) {
    state: AssaysViewModalState

    constructor() {
        super()
        this.state = initialAssaysViewModalState()
    }

    @Prop(Number) readonly casId!: number
    @Prop() readonly priorityCas!: CommonPriorityResponse

    @Watch('state.selectedSubportions')
    onSelectedSubportionsChange(): void {
        if (this.state.selectedSubportions.length === 1) {
            const selectedSubportion = this.state.selectedSubportions[0]
            this.state.selectedAssay = selectedSubportion.assay as AssayModalAssayWithValuableConceptResponse
            this.state.selectedPriority = selectedSubportion.priority
            this.state.selectedDevice = selectedSubportion.assayDevice
        } else if (this.state.selectedSubportions.length > 1) {
            this.state.selectedAssay = null
            this.state.selectedPriority = null
            this.state.selectedDevice = null
            this.state.selectedPortionType = null
        }
    }
    @Watch('state.selectedPortions')
    onSelectedPortionsChange(): void {
        if (this.state.selectedPortions.length) {
            this.state.selectedPriority = this.priorityCas
            this.state.selectedAssay = null
            this.state.selectedDevice = null
        }
    }

    @Ref('assaysViewModal') readonly assaysViewModal!: BModal
    @Ref('tree') readonly tree!: LiquorTree
    @Ref('ctxMenu') readonly ctxMenu: any
    @Ref('printComponent') readonly printComponent: any
    @Ref('protocolsModal') readonly protocolsModal!: AssaysViewBatchModalProtocols
    @Ref('techsModal') readonly techsModal!: AssaysViewBatchModalAssays
    @Ref('addFileModal') readonly addFileModal: any
    @Ref('incidentFormModalWrapper') readonly incidentFormModalWrapper: any
    @Ref('itemsForShippingModal') readonly itemsForShippingModal: any
    @Ref('cancelSubportionsQuestionConfirmationModal') readonly cancelSubportionsQuestionConfirmationModal: any

    get sidebarSampleLabel(): string {
        return this.state.sidebarSample?.sampleNumber ?? ''
    }
    get sidebarPortionLabel(): string {
        return this.state.sidebarPortion?.portionNumber ?? ''
    }
    get sidebarSubportionLabel(): string {
        return this.state.sidebarSubportion?.subportionNumber ?? ''
    }
    get sidebarHasSubportion(): boolean {
        return !!this.state.sidebarSubportion
    }
    get attachmentEntityLabel(): string {
        let label = `${this.state.caseNode?.data.caseNumber}-${this.sidebarPortionLabel}`
        if (this.sidebarHasSubportion) {
            return `${label}-${this.sidebarSubportionLabel}`
        }
        return label
    }

    get visiblePortionCreation(): boolean {
        return !!this.state.selectedSamples.length && this.$_canCreatePortion()
    }
    get disabledPortionCreation(): boolean {
        return this.state.selectedSamples.some(sample => !this.$_canBePortionCreatedToSample(sample)) ||
            !this.state.selectedPortionType ||
            this.state.portionNumberOfCopies < 1
    }
    get disabledPortionDeletion(): boolean {
        return this.state.selectedPortions.some(portion => !this.$_canBePortionDeleted(portion))
    }
    get disabledPortionCassettePrint(): boolean {
        return this.state.selectedPortions.some(portion => !this.$_canBePortionCassettePrinted(portion))
    }
    get visiblePortionCancellation(): boolean {
        return this.state.selectedPortions.every(portion => this.$_canBePortionCancelled(portion)) &&
            this.$_canCancelPortion()
    }
    get disabledPortionCancellation(): boolean {
        return !this.state.selectedCancellationReason
    }
    get visiblePortionOperations(): boolean {
        return !!this.state.selectedPortions.length
    }
    get visibleSubportionCreation(): boolean {
        return this.state.selectedPortions.every(portion => this.$_canBeAssayRequestedToPortion(portion)) &&
            this.$_canCreateSubportion()
    }
    get disabledDeviceSelection(): boolean {
        return !this.state.selectedAssay
    }
    get disabledSubportionCreation(): boolean {
        return !this.state.selectedAssay ||
            !this.state.selectedPriority
    }
    get disabledProtocolsModal(): boolean {
        return this.state.selectedPortions.some(portion => !this.$_canBeAssayRequestedToPortion(portion))
    }
    get disabledAssaysModal(): boolean {
        return this.disabledProtocolsModal
    }
    get visibleSubportionOperations(): boolean {
        return !!this.state.selectedSubportions.length
    }
    get visibleSubportionModification(): boolean {
        return this.state.selectedSubportions.every(subportion => this.$_canBeAssayModifiedToSubportion(subportion)) &&
            this.$_canEditSubportion()
    }
    get disabledSubportionModification(): boolean {
        return !this.state.selectedAssay ||
            !this.state.selectedPriority
    }
    get visibleSubportionCancellation(): boolean {
        return this.state.selectedSubportions.every(subportion => this.$_canBeSubportionCancelled(subportion)) &&
            this.$_canCancelSubportion()
    }
    get disabledSubportionCancellation(): boolean {
        return !this.state.selectedCancellationReason
    }
    get disabledSubportionDeletion(): boolean {
        return this.state.selectedSubportions.some(subportion => !this.$_canBeSubportionDeleted(subportion))
    }
    get disabledSubportionDiscard(): boolean {
        return this.state.selectedSubportions.some(subportion => !this.$_canBeSubportionDiscarded(subportion))
    }
    get disabledSubportionLabelPrint(): boolean {
        return this.state.selectedSubportions.some(subportion => !this.$_canBeSubportionPrinted(subportion))
    }
    get disabledSubportionCopy(): boolean {
        return this.state.selectedSubportions.some(subportion => !this.$_canBeAssayRequestedInParentPortionToSubportion(subportion))
    }

    get visibleSubportionCopy(): boolean {
        return this.$_hasOperationInCurrentLaboratory(SubportionOperation.CREATE)
    }
    // TODO: remove or finish current partial implementation of shipment functionality once it's analysis is complete
    get visiblePortionShipmentRequestCreation(): boolean {
        return this.state.selectedPortions.every(selectedPortion => selectedPortion.portionTypeEnum !== PORTION_TYPES.VIRTUAL.key)
    }
    // TODO: remove or finish current partial implementation of shipment functionality once it's analysis is complete
    get visibleSubportionShipmentRequestCreation(): boolean {
        return this._canCreateShipmentRequest(this.state.selectedSubportions)
    }
    get visibleCreatePortion(): boolean {
        return this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.PORTION &&
            (this.state.selectedNodeForContextMenu?.data as Nullable<AssaysViewPortionResponse>)?.portionTypeEnum !== PORTION_TYPES.VIRTUAL.key &&
            this.state.selectedPortions.length <= 1 &&
            this.$_canCreateIncident() &&
            this.$_canBeIncidentCreatedToPortion(this.state.selectedNodeForContextMenu?.data)
    }
    get visibleDocumentAttachmentToPortion(): boolean {
        return this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.PORTION &&
            (this.state.selectedNodeForContextMenu?.data as Nullable<AssaysViewPortionResponse>)?.portionTypeEnum !== PORTION_TYPES.VIRTUAL.key &&
            this.state.selectedPortions.length <= 1 &&
            this.$_canAttachDocumentToPortion() &&
            this.$_canBeDocumentAttachedToPortion(this.state.selectedNodeForContextMenu?.data)
    }
    get visibleShowInGlobalLocatorToPortion(): boolean {
        return this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.PORTION &&
            this.state.selectedPortions.length <= 1
    }
    get visibleIncidentCreationToSubportion(): boolean {
        return this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.SUBPORTION &&
            this.state.selectedSubportions.length <= 1 &&
            this.$_canCreateIncident() &&
            this.$_canBeIncidentCreatedToSubportion(this.state.selectedNodeForContextMenu?.data)
    }
    get visibleDocumentAttachmentToSubportion(): boolean {
        return this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.SUBPORTION &&
            this.state.selectedSubportions.length <= 1 &&
            this.$_canAttachDocumentToSubportion() &&
            this.$_canBeDocumentAttachedToSubportion(this.state.selectedNodeForContextMenu?.data)
    }
    get visibleSubportionDiscard(): boolean {
        return this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.SUBPORTION &&
            this.$_canBeSubportionDiscarded(this.state.selectedNodeForContextMenu?.data)
    }
    get visibleSubportionUnDiscard(): boolean {
        return this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.SUBPORTION &&
            this.$_canBeSubportionUnDiscarded(this.state.selectedNodeForContextMenu?.data)
    }
    get visibleShowInGlobalLocatorToSubportion(): boolean {
        return this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.SUBPORTION &&
            this.state.selectedPortions.length <= 1
    }
    get visibleEmptyState(): boolean {
        return !this.state.selectedPortions.length &&
            !this.state.selectedSubportions.length &&
            !this.state.selectedSamples.length
    }

    get selectedNodeContextMenuIsTypeSample(): boolean {
        return this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.SAMPLE
    }
    get selectedNodeContextMenuIsTypePortion(): boolean {
        return this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.PORTION
    }

    get labId(): number {
        return this.$store.getters.labId
    }
    get isPersonnel(): boolean {
        return this.$store.getters.userInformation?.userType === UserType.PERSONNEL
    }

    get assayStates(): Object {
        return ASSAY_STATES
    }
    get portionTypeEnum(): typeof PortionTypeEnum {
        return PortionTypeEnum
    }

    get fullAssayStates(): any[] {
        return assayState.states
    }
    get priorities(): CommonPriorityResponse[] {
        const priorities: CommonPriorityResponse[] = sessionStore.state.priorities
        return priorities.filter(priority => priority.active)
    }

    get hasURVActive(): boolean {
        const activeModule =
            StoreUtils.selectedLaboratoryConfiguration?.activeModules.find(
                module => module.moduleCode === 'configuration.parameter.laboratory.module.accountancy.urv.active')
        return !!activeModule?.activeStatus
    }

    get loadedAssaysLaboratoryIdsToString(): string {
        return this.state.assaysLoadLaboratoryIds.toString()
    }

    /// SHIPMENTS

    // TODO: remove or finish current partial implementation of shipment functionality once it's analysis is complete
    contextMenuValidationToSend(selectedNodeForContextMenu: AssaysViewNode): boolean {
        return this.$_canCreateShipmentRequest() &&
            selectedNodeForContextMenu.text !== AssaysViewTypeEnum.SAMPLE &&
            (!('portionTypeEnum' in selectedNodeForContextMenu.data) || selectedNodeForContextMenu.data.portionTypeEnum !== PortionTypeEnum.VIRTUAL) &&
            this._canCreateShipmentRequest([selectedNodeForContextMenu.data])
    }
    // TODO: remove or finish current partial implementation of shipment functionality once it's analysis is complete
    private _canCreateShipmentRequest(elements: { status: { code: string } }[]): boolean {
        return elements.every((element: { status: { code: string } }) => ![
            SUBPORTION_STATES.DISCARDED.code,
            SUBPORTION_STATES.CANCELED.code,
            SUBPORTION_STATES.OUT_OF_LABORATORY.code
        ].includes(element.status.code))
    }
    // TODO: remove or finish current partial implementation of shipment functionality once it's analysis is complete
    checkToSend(): void {
        this.state.portionsToSend = []
        this.state.subportionsToSend = []

        if (this.state.selectedNodeForContextMenu) {
            if (this.state.selectedNodeForContextMenu.text === AssaysViewTypeEnum.PORTION) {
                this.state.portionsToSend = [this.state.selectedNodeForContextMenu?.data as AssaysViewPortionResponse]
            } else if (this.state.selectedNodeForContextMenu.text === AssaysViewTypeEnum.SUBPORTION) {
                this.state.subportionsToSend = [this.state.selectedNodeForContextMenu?.data as AssaysViewSubportionResponse]
            }
        } else {
            this.state.portionsToSend = this.state.selectedPortions
            this.state.subportionsToSend = this.state.selectedSubportions
        }

        this.itemsForShippingModal.show()
    }

    ///

    generationPersonnelTooltipText(nodeData: AssaysViewPortionResponse): string {
        return nodeData.generationPersonnel ? `${this.$tc('component.techniquesModal.making')}:<br>${nodeData.generationPersonnel.fullName}` : ''
    }
    cancelledByTooltipText(nodeData: AssaysViewPortionResponse): string {
        return nodeData.cancelledBy ? `${this.$tc('component.techniquesModal.cancellation')}:<br>${nodeData.cancelledBy.fullName}` : ''
    }

    async showProtocols(): Promise<void> {
        await this.protocolsModal.show(this.state.selectedPortions)
    }
    async showTechs(): Promise<void> {
        await this.techsModal.show(this.state.selectedPortions)
    }
    showInGlobalLocator(label:any) {
        this.$eventHub.$emit('show-in-global-locator', label)
    }
    private _getIncidentEntityIdHierarchy(entity: AssaysViewPortionResponse | AssaysViewSubportionResponse): IncidentEntityIdHierarchy {
        const incidentHierarchy: IncidentEntityIdHierarchy = {
            casId: this.state.caseNode?.data.casId,
            samId: entity.sampleId,
            porId: entity.portionId
        }
        if ('subportionId' in entity) {
            incidentHierarchy.supId = entity.subportionId
        } else {
            incidentHierarchy.portionTypeEnum = entity.portionTypeEnum
        }
        return incidentHierarchy
    }
    private async _showIncidentFormModal(
        coreEntity: IncidentEntityType,
        entityInformation: IncidentEntityIdHierarchy,
        incidentId?: number
    ): Promise<void> {
        this.state.coreEntity = coreEntity
        this.$nextTick(async () => {
            await this.incidentFormModalWrapper.show([null, entityInformation, incidentId])
            this.state.assayViewModalSidepanel = false
        })
    }
    async openIncidentModal(incidentId: number, incidentEntityType: EnumResponse): Promise<void> {
        if (this.isPersonnel && (this.state.sidebarPortion || this.state.sidebarSubportion)) {
            const entity = incidentEntityType.code === IncidentEntityType.PORTION ? this.state.sidebarPortion : this.state.sidebarSubportion
            const entityType = incidentEntityType.code === IncidentEntityType.PORTION
                ? IncidentEntityType.PORTION : IncidentEntityType.SUBPORTION
            if (entity) {
                await this._showIncidentFormModal(
                    entityType,
                    this._getIncidentEntityIdHierarchy(entity),
                    incidentId)
            }
        }
    }
    private async _showAttachmentModal(entity: AttachmentEntityType, entitiesIdArray: number[]): Promise<void> {
        this.state.attachmentEntityType = entity
        this.state.entitiesIdArray = entitiesIdArray
        await this.addFileModal.show()
    }

    async onAttachmentsAdded(): Promise<void> {
        await this.loadCaseNode()
    }
    async onAttachmentDeleted(): Promise<void> {
        await this.loadCaseNode()
    }

    ///

    private _getCurrentLaboratoryIdsBySelectedEntities(): number[] {
        let entities: (AssaysViewPortionResponse | AssaysViewSubportionResponse)[] = []
        if (this.state.selectedPortions.length) {
            entities = this.state.selectedPortions
        } else if (this.state.selectedSubportions.length) {
            entities = this.state.selectedSubportions
        }
        return uniq(entities.map(entity => entity.currentLaboratory.labId))
    }

    private static _getPortionIdHierarchies(portions: AssaysViewPortionResponse[]): HierarchicalPortionTreeRequest[] {
        return portions.map(portion => ({
            portionId: portion.portionId,
            sampleId: portion.sampleId
        }))
    }

    // TODO: pendent to backend review -> AssaysViewSubportionResponse returns a CommonAssayResponse instead of an AssayModalAssayWithValuableConceptResponse
    getGroupedAssayLabel(assay: AssayModalAssayWithValuableConceptResponse): string {
        const label = `${assay.name} - ${assay.assaygroup.name}`
        return this.hasURVActive && assay.urv ? `${label} ( URV ${assay.urv} )` : label
    }

    /// CONTEXT MENU TREE OPERATIONS

    selectSamples(): void {
        this.tree.findAll(AssaysViewTypeEnum.SAMPLE)?.check()
    }
    deselectSamples(): void {
        this.tree.findAll(AssaysViewTypeEnum.SAMPLE)?.uncheck()
    }
    selectPortions(): void {
        this.tree.findAll(AssaysViewTypeEnum.PORTION)?.check()
        this.tree.expandAll()
    }
    selectNodeChildren(): void {
        if (this.state.selectedNodeForContextMenu) {
            this.state.selectedNodeForContextMenu.expand()

            for (const child of this.state.selectedNodeForContextMenu.children) {
                child.check()
                child.expand()
            }
        }
    }

    onNodeUnchecked(node: AssaysViewNode): void {
        if ('samId' in node.data) {
            const sample = node.data as AssaysViewSampleResponse
            const samIndex = this.state.selectedSamples.findIndex(
                selectedSample => selectedSample.samId === sample.samId)
            if (samIndex >= 0) {
                this.state.selectedSamples.splice(samIndex, 1)
            }
        } else if ('subportionId' in node.data) {
            const subportion = node.data as AssaysViewSubportionResponse
            const subportionIndex = this.state.selectedSubportions.findIndex(
                selectedSubportion => selectedSubportion.subportionId === subportion.subportionId)
            if (subportionIndex >= 0) {
                this.state.selectedSubportions.splice(subportionIndex, 1)
            }
            this.updateAssaysLoadLaboratoryIdsIfNecessary()
        } else if ('portionId' in node.data) {
            const portion = node.data as AssaysViewPortionResponse
            const portionIndex = this.state.selectedPortions.findIndex(
                selectedPortion => selectedPortion.portionId === portion.portionId)
            if (portionIndex >= 0) {
                this.state.selectedPortions.splice(portionIndex, 1)
            }
            this.updateAssaysLoadLaboratoryIdsIfNecessary()
        }
    }
    async onNodeChecked(node: AssaysViewNode): Promise<void> {
        if ('samId' in node.data) {
            const portionAndSubportionsChecked =
                this.tree.findAll({
                    text: new RegExp(`(^${AssaysViewTypeEnum.PORTION}$|^${AssaysViewTypeEnum.SUBPORTION}$)`),
                    state: { checked: true }
                })
            portionAndSubportionsChecked?.uncheck()
            this.state.selectedSamples.push(node.data as AssaysViewSampleResponse)
        } else if ('subportionId' in node.data) {
            const samplesAndPortionsChecked =
                this.tree.findAll({
                    text: new RegExp(`(^${AssaysViewTypeEnum.SAMPLE}$|^${AssaysViewTypeEnum.PORTION}$)`),
                    state: { checked: true }
                })
            samplesAndPortionsChecked?.uncheck()
            this.state.selectedSubportions.push(node.data as AssaysViewSubportionResponse)

            this.updateAssaysLoadLaboratoryIdsIfNecessary()
            await this.loadDevices()
        } else if ('portionId' in node.data) {
            const subportionsAndSamplesChecked =
                    this.tree.findAll({
                        text: new RegExp(`(^${AssaysViewTypeEnum.SUBPORTION}$|^${AssaysViewTypeEnum.SAMPLE}$)`),
                        state: { checked: true }
                    })
            subportionsAndSamplesChecked?.uncheck()
            this.state.selectedPortions.push(node.data as AssaysViewPortionResponse)

            this.updateAssaysLoadLaboratoryIdsIfNecessary()
            await this.loadDevices()
        }
    }

    showAllElements(): void {
        this.state.display = false
        this.tree.expandAll()
    }
    hideAllElements(): void {
        this.state.display = true
        this.tree.collapseAll()
    }

    visibleHasUnauthorizedBillableConceptsIcon(hasUnauthorizedBillableConcepts: boolean): boolean {
        return ModuleOperationGuard.canAccessBilling && hasUnauthorizedBillableConcepts
    }

    private get _visibleContextMenu(): boolean {
        const contextMenuHasChildren =
            this.selectedNodeContextMenuIsTypeSample ||
            this.selectedNodeContextMenuIsTypePortion ||
            this.visibleSubportionDiscard ||
            this.visibleSubportionUnDiscard ||
            this.visibleCreatePortion ||
            this.visibleDocumentAttachmentToPortion ||
            this.visibleIncidentCreationToSubportion ||
            this.visibleDocumentAttachmentToSubportion
        return this.state.selectedNodeForContextMenu! &&
            contextMenuHasChildren
    }
    openContextMenu(node: AssaysViewNode): void {
        this.state.selectedNodeForContextMenu = null
        this.state.selectedNodeForContextMenu = node
        if (!node.checked()) {
            this.tree.checked()?.uncheck()
            node.check()
        }
        this.$forceUpdate()
        this.$nextTick(() => {
            if (this.ctxMenu && this._visibleContextMenu) {
                this.ctxMenu.open()
            }
        })
    }

    private _openTreeByEntity(entitiesToFocus: LabeledEntity[]): void {
        setTimeout(() => {
            if (entitiesToFocus?.length) {
                entitiesToFocus.forEach(entity => {
                    const entitySelection = this.tree.find<AssaysViewNode>({ data: { label: entity.label } })
                    if (entitySelection) {
                        entitySelection.expand()
                        entitySelection.check()

                        const node = entitySelection[0]
                        if (node) {
                            for (const child of node.children) {
                                child.expand()
                            }

                            const parent = node.parent
                            if (parent) {
                                parent.expand()

                                if (parent.parent) {
                                    parent.parent.expand()
                                }
                            }
                        }
                    }
                })
            }
        }, 0)
    }

    // PORTIONS OPERATIONS

    async addPortions(): Promise<void> {
        if (this.state.selectedPortionType) {
            const samples =
                this.state.selectedSamples.map(sample => ({ sampleId: sample.samId } as HierarchicalSampleTreeRequest))
            if (samples.length) {
                await this.createPortionsBatch(samples)
            }
        }
    }
    async createPortionsBatch(samples: HierarchicalSampleTreeRequest[]): Promise<void> {
        if (this.state.selectedPortionType) {
            const caseId: Nullable<number> = this.state.caseNode?.data.casId
            if (!caseId) {
                this.$_showErrorModal()
                return
            }

            this.$_updateLoading(true)
            try {
                const response =
                    await this.$_toCallSecureLoading(
                        assaysViewPortionService.createPortions(
                            this.labId,
                            caseId,
                            this.state.portionNumberOfCopies,
                            samples,
                            this.state.selectedPortionType.potId))
                if (response) {
                    this.state.portionNumberOfCopies = 1
                    this.state.selectedPortionType = null
                    this.$_showSuccessModal(this.$tc('component.assaysViewModal.portionsCreatedSuccess'))
                    this.$emit('portionsUpdated')

                    await this.loadCaseNode()
                    this.$forceUpdate()
                }
            } finally {
                this.$_updateLoading(false)
            }
        }
    }
    async deletePortionsBatch(): Promise<void> {
        if (await this.$_showConfirmationModal(this.$tc('component.assaysViewModal.deleteConfirmation'))) {
            this.$_updateLoading(true)
            try {
                const portionsToDelete = AssaysViewModal._getPortionIdHierarchies(this.state.selectedPortions)
                const response =
                    await this.$_toCallSecureLoading(
                        assaysViewPortionService.deletePortions(
                            this.labId,
                            this.casId,
                            portionsToDelete))
                if (response !== null) {
                    this.$_showSuccessModal(this.$tc('component.assaysViewModal.portionsDeletedSuccess'))
                    this.$emit('portionsUpdated')

                    await this.loadCaseNode()
                    this.$forceUpdate()
                }
            } finally {
                this.$_updateLoading(false)
            }
        }
    }
    async cancelPortions(): Promise<void> {
        if (await this.$_showConfirmationModal(this.$tc('component.assaysViewModal.cancelConfirmation'))) {
            if (!this.state.selectedCancellationReason) {
                console.error('null cancellation reason')
                this.$_showErrorModal()
                return
            }

            this.$_updateLoading(true)
            try {
                const portionsToCancel: AssaysViewPortionsCancelRequest[] = []
                for (let portion of this.state.selectedPortions) {
                    const portionToCancel: AssaysViewPortionsCancelRequest = {
                        sampleId: portion.sampleId,
                        portionId: portion.portionId,
                        cancellationReasonId: this.state.selectedCancellationReason.id
                    }
                    portionsToCancel.push(portionToCancel)
                }

                if (portionsToCancel.length) {
                    const [error] =
                        await this.$_toCall(
                            assaysViewPortionService.cancelPortions(
                                this.labId,
                                this.casId,
                                portionsToCancel))
                    if (error) {
                        const errorMessage = error.response?.data?.message ?? ''
                        this.$_showErrorModal(`${this.$tc('component.assaysViewModal.portionsCancelledError')}: ${errorMessage}`)
                        return
                    }

                    this.state.selectedCancellationReason = null
                    this.$_showSuccessModal(this.$tc('component.assaysViewModal.portionsCancelledSuccess'))

                    await this.loadCaseNode()
                    this.$forceUpdate()
                }
            } finally {
                this.$_updateLoading(false)
            }
        }
    }
    async printPortionsLabels(): Promise<void> {
        if (this.state.selectedPortions.length) {
            this.$_updateLoading(true)
            try {
                const portionsGroupedBySample: Dictionary<AssaysViewPortionResponse[]> =
                    groupBy(
                        this.state.selectedPortions.filter(selectedPortion =>
                            selectedPortion.portionTypeEnum &&
                            selectedPortion.portionTypeEnum !== PortionTypeEnum.VIRTUAL),
                        'sampleId')
                for (const [sampleId, selectedPortions] of Object.entries(portionsGroupedBySample)) {
                    const sample: Nullable<AssaysViewSampleResponse> = this.state.samples.find(sample => sample.samId === +sampleId)
                    if (!sample) {
                        this.$_showErrorModal()
                        return
                    }

                    const portions = selectedPortions.map(portion => ({
                        id: portion.portionId,
                        label: portion.label,
                        printLabelDate: portion.printLabelDate
                    }))
                    await this.printComponent.printCassetteLabels(
                        sample.currentLaboratory.labId,
                        this.casId,
                        sample.samId,
                        portions,
                        this.state.caseNode?.data.priority,
                        sample.sampleType.id,
                        sample.topographicCodeId)
                }

                await this.loadCaseNode()
            } finally {
                this.$_updateLoading(false)
            }
        }
    }

    async createIncidentToPortion(): Promise<void> {
        if (this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.PORTION) {
            const portion = this.state.selectedNodeForContextMenu?.data as AssaysViewPortionResponse
            await this._showIncidentFormModal(
                IncidentEntityType.PORTION,
                this._getIncidentEntityIdHierarchy(portion))
        }
    }
    async showPortionIncidentsSidepanel(
        portion: AssaysViewPortionResponse,
        sample: AssaysViewSampleResponse
    ): Promise<void> {
        const response =
                await this.$_toCallUnique(
                    incidentServices.getPortionIncidents(
                        portion.currentLaboratory.labId,
                        this.casId,
                        portion.sampleId,
                        portion.portionId))
        if (response) {
            this.state.incidents = response
            this.state.assayViewModalSidepanel = true
            this.state.isIncidentSidepanel = true
            this.state.isAttachmentSidepanel = false
            this.state.sidebarSample = sample
            this.state.sidebarPortion = portion
            this.state.sidebarSubportion = null
        }
    }

    async attachDocumentToPortion(): Promise<void> {
        if (this.state.caseNode) {
            const portion = this.state.selectedNodeForContextMenu?.data as AssaysViewPortionResponse
            const portionIdsArray = [
                portion.currentLaboratory.labId,
                this.state.caseNode.data.casId,
                portion.sampleId,
                portion.portionId
            ]
            await this._showAttachmentModal(AttachmentEntityType.PORTION, portionIdsArray)
        }
    }
    showPortionAttachmentsSidepanel(
        portion: AssaysViewPortionResponse,
        sample: AssaysViewSampleResponse
    ): void {
        this.state.entitiesIdArray = [portion.currentLaboratory.labId, this.casId, portion.sampleId, portion.portionId]
        this.state.attachmentEntityType = AttachmentEntityType.PORTION
        this.state.assayViewModalSidepanel = true
        this.state.isAttachmentSidepanel = true
        this.state.isIncidentSidepanel = false
        this.state.sidebarSample = sample
        this.state.sidebarPortion = portion
    }

    // SUBPORTIONS OPERATIONS

    async createSubportions(): Promise<void> {
        if (this.state.selectedAssay && this.state.selectedPriority) {
            this.$_updateLoading(true)
            try {
                sortBy(this.state.selectedPortions, 'portionNumber')
                const subportionsToBeCreated: AssaysViewApplyAssaysRequest = {
                    assays: [
                        {
                            assayId: this.state.selectedAssay.id,
                            priorityId: this.state.selectedPriority.id,
                            assayDeviceId: this.state.selectedDevice?.id
                        }
                    ],
                    hierarchicalPortionTreeRequest: AssaysViewModal._getPortionIdHierarchies(this.state.selectedPortions)
                }
                const response =
                    await this.$_toCallSecureLoading(
                        assaysViewSubportionService.createSubportions(
                            this.labId,
                            this.casId,
                            this.state.subportionNumberOfCopies,
                            subportionsToBeCreated))
                if (response) {
                    this.state.selectedAssay = null
                    this.state.selectedPriority = this.priorityCas
                    this.state.devices = []
                    this.state.selectedDevice = null
                    this.state.subportionNumberOfCopies = 1

                    this.$_showSuccessModal(this.$tc('component.assaysViewModal.assaysCreatedSuccess'))
                    this.$emit('subportionsAdded')

                    await this.loadCaseNode()
                }
            } finally {
                this.$_updateLoading(false)
            }
        }
    }
    private async _updateSubportion(
        subportion: AssaysViewSubportionResponse,
        assayId: Nullable<number>,
        priorityId: Nullable<number>,
        assayDeviceId: Nullable<number>
    ): Promise<any> {
        const subportionsToBeUpdated: HierarchicalSubportionTreeRequest = {
            sampleId: subportion.sampleId,
            portionId: subportion.portionId,
            subportionId: subportion.subportionId,
            originalConcurrencyUpdatedAt: subportion.originalConcurrencyUpdatedAt
        }
        const [err] =
            await this.$_toCall(
                assaysViewSubportionService.updateSubportions(
                    subportion.currentLaboratory.labId,
                    this.casId,
                    [subportionsToBeUpdated],
                    assayId,
                    priorityId,
                    assayDeviceId))
        if (err) {
            if (err.response?.data?.code === apiExceptionType.CONCURRENCY_ERROR) {
                /**
                 * Returns an error if the update operation was not successful or null if it was successful
                 */
                return this.$_processBasicConcurrencyConflict(
                    `${this.$tc('global.technique')} - ${subportion.label}`,
                    err,
                    () => {
                        subportion.originalConcurrencyUpdatedAt = err.response.data.currentConcurrencyUpdatedAt
                        return this._updateSubportion(subportion, assayId, priorityId, assayDeviceId)
                    })
            }
            return err
        }
        return null
    }
    async updateSubportions(): Promise<void> {
        if (this.state.selectedAssay || this.state.selectedPriority || this.state.selectedDevice) {
            this.$_updateLoading(true)
            try {
                const assayId = this.state.selectedAssay?.id ?? null
                const priorityId = this.state.selectedPriority?.id ?? null
                const assayDeviceId = this.state.selectedDevice?.id ?? null

                for (const subportion of this.state.selectedSubportions) {
                    const error = await this._updateSubportion(subportion, assayId, priorityId, assayDeviceId)
                    if (error) {
                        this.$_showErrorModalFromErrorResponse(error)
                        return
                    }
                }

                this.state.selectedAssay = null

                this.state.selectedPriority = null

                this.state.devices = []
                this.state.selectedDevice = null

                this.$_showSuccessModal(this.$tc('component.assaysViewModal.assaysUpdatedSuccess'))
                this.$emit('subportionsUpdated')

                await this.loadCaseNode()
            } finally {
                this.$_updateLoading(false)
            }
        }
    }
    async deleteSubportions(): Promise<void> {
        if (await this.$_showConfirmationModal(this.$tc('component.assaysViewModal.deleteConfirmation'))) {
            const subportionsWithAttachmentsOrIncidents = this.state.selectedSubportions.some(subportion => subportion.attachmentsCount || subportion.incidentsCount)
            if (subportionsWithAttachmentsOrIncidents) {
                if (!await this.$_showConfirmationModal(this.$tc('component.assaysViewModal.deleteSubportionWarning'))) {
                    return
                }
            }

            this.$_updateLoading(true)
            try {
                const subportionsToBeDeleted: HierarchicalSubportionTreeRequest[] =
                    this.state.selectedSubportions.map(subportion => ({
                        sampleId: subportion.sampleId,
                        portionId: subportion.portionId,
                        subportionId: subportion.subportionId,
                        originalConcurrencyUpdatedAt: subportion.originalConcurrencyUpdatedAt
                    }))
                if (subportionsToBeDeleted.length) {
                    const [error] =
                        await this.$_toCall(
                            assaysViewSubportionService.deleteSubportions(
                                this.labId,
                                this.casId,
                                subportionsToBeDeleted))
                    if (error) {
                        const errorMessage = error.response?.data?.message ?? ''
                        this.$_showErrorModal(`${this.$tc('component.assaysViewModal.assaysDeletedError')}: ${errorMessage}`)
                        return
                    }

                    this.state.selectedCancellationReason = null
                    this.$_showSuccessModal(this.$tc('component.assaysViewModal.assaysDeletedSuccess'))
                    this.$emit('subportionsUpdated')
                    await this.loadCaseNode()
                    this.$forceUpdate()
                }
            } finally {
                this.$_updateLoading(false)
            }
        }
    }
    async duplicateSubportions(): Promise<void> {
        this.$_updateLoading(true)
        try {
            const subportionsToBeCreated: AssaysViewApplyAssaysRequest = {
                assays: this.state.selectedSubportions.map(subportion => ({
                    assayId: subportion.assay?.id,
                    priorityId: subportion.priority?.id,
                    assayDeviceId: subportion.assayDevice?.id
                })),
                hierarchicalPortionTreeRequest: uniqBy(
                    this.state.selectedSubportions.map(subportion => ({
                        sampleId: subportion.sampleId,
                        portionId: subportion.portionId
                    })),
                    'portionId')
            }
            const response = await this.$_toCallSecureLoading(
                assaysViewSubportionService.createSubportions(
                    this.labId,
                    this.casId,
                    this.state.duplicateNumberOfCopies,
                    subportionsToBeCreated))
            if (response) {
                this.state.duplicateNumberOfCopies = 1
                this.$_showSuccessModal(this.$tc('component.assaysViewModal.assaysDuplicatedSuccess'))
                this.$emit('portionsUpdated')

                await this.loadCaseNode()
            }
        } finally {
            this.$_updateLoading(false)
        }
    }
    async cancelSubportions(): Promise<void> {
        if (await this.$_showConfirmationModal(this.$tc('component.assaysViewModal.cancelConfirmation'))) {
            if (!this.state.selectedCancellationReason) {
                console.error('null cancellation reason')
                this.$_showErrorModal()
                return
            }

            try {
                const subportionsToBeCancelled: AssaysViewSubportionsCancelRequest[] = []
                let currentDontShowAgainCheckStatus = null
                let currentBatchAction = false
                for (const subportion of this.state.selectedSubportions) {
                    const subportionMapped = {
                        sampleId: subportion.sampleId,
                        portionId: subportion.portionId,
                        subportionId: subportion.subportionId,
                        cancellationReasonId: this.state.selectedCancellationReason.id,
                        shouldBeReplaced: currentBatchAction
                    }
                    if (currentDontShowAgainCheckStatus) {
                        subportionMapped.shouldBeReplaced = currentBatchAction
                    } else {
                        const confirmationModalParams = {
                            question: this.$tc(
                                'component.assaysViewModal.cancelAssayQuestion',
                                1,
                                { subportion: subportion.label }),
                            dontShowAgainCheckableText: this.$tc('component.assaysViewModal.cancelAssaysCheckboxMessage')
                        }
                        const confirmationModalResponseFunction = await this.$_showConfirmationModalCheckable(confirmationModalParams)
                        if (confirmationModalResponseFunction) {
                            subportionMapped.shouldBeReplaced = confirmationModalResponseFunction.buttonAction
                            currentDontShowAgainCheckStatus = confirmationModalResponseFunction.dontShowAgainCheckStatus
                            currentBatchAction = confirmationModalResponseFunction.buttonAction
                        }
                    }
                    subportionsToBeCancelled.push(subportionMapped)
                }

                if (subportionsToBeCancelled.length) {
                    const response = await this.$_toCallUnique(
                        assaysViewSubportionService.cancelSubportions(
                            this.labId,
                            this.casId,
                            subportionsToBeCancelled),
                        error => {
                            const errorMessage = error.response?.data?.message ?? ''
                            this.$_showErrorModal(`${this.$tc('component.assaysViewModal.assaysCancelledError')}: ${errorMessage}`)
                        }
                    )
                    if (response !== null) {
                        this.state.selectedCancellationReason = null
                        this.$_showSuccessModal(this.$tc('component.assaysViewModal.assaysCancelledSuccess'))
                        await this.loadCaseNode()
                        this.$forceUpdate()
                    }
                }
            } finally {
                this.$_updateLoading(false)
            }
        }
    }
    async discardSubportion(): Promise<void> {
        if (this.state.selectedSubportions.length) {
            const subportionsToBeDiscarded: HierarchicalSubportionTreeRequest[] = this.state.selectedSubportions?.map((subportion: AssaysViewSubportionResponse) => {
                return {
                    portionId: subportion.portionId,
                    sampleId: subportion.sampleId,
                    subportionId: subportion.subportionId,
                    originalConcurrencyUpdatedAt: subportion.originalConcurrencyUpdatedAt
                }
            })
            if (subportionsToBeDiscarded.length) {
                this.$_updateLoading(true)
                try {
                    const [error] =
                        await this.$_toCall(
                            assaysViewSubportionService.discardSubportions(
                                this.labId,
                                this.casId,
                                subportionsToBeDiscarded))
                    if (error) {
                        const errorMessage = error.response?.data?.message ?? ''
                        this.$_showErrorModal(`${this.$tc('component.assaysViewModal.assaysDiscardedError')}: ${errorMessage}`)
                        return
                    }

                    this.$_showSuccessModal(this.$tc('component.assaysViewModal.assaysDiscardedSuccess'))

                    await this.loadCaseNode()
                    this.$forceUpdate()
                } finally {
                    this.$_updateLoading(false)
                }
            }
        }
    }
    async unDiscardSubportion(): Promise<void> {
        const subportionsToBeUnDiscarded: HierarchicalSubportionTreeRequest[] = this.state.selectedSubportions?.map((subportion: AssaysViewSubportionResponse) => {
            return {
                portionId: subportion.portionId,
                sampleId: subportion.sampleId,
                subportionId: subportion.subportionId,
                originalConcurrencyUpdatedAt: subportion.originalConcurrencyUpdatedAt
            }
        })
        if (subportionsToBeUnDiscarded.length) {
            this.$_updateLoading(true)
            try {
                const [error] =
                    await this.$_toCall(
                        assaysViewSubportionService.undoDiscardSubportions(
                            this.labId,
                            this.casId,
                            subportionsToBeUnDiscarded))
                if (error) {
                    const errorMessage = error.response?.data?.message ?? ''
                    this.$_showErrorModal(`${this.$tc('component.assaysViewModal.assaysUndiscardedError')}: ${errorMessage}`)
                    return
                }

                this.$_showSuccessModal(this.$tc('component.assaysViewModal.assaysUndiscardedSuccess'))

                await this.loadCaseNode()
                this.$forceUpdate()
            } finally {
                this.$_updateLoading(false)
            }
        }
    }
    async printSubportionsLabels(): Promise<void> {
        if (this.state.selectedSubportions.length) {
            for (const item of this.state.selectedSubportions) {
                await this.printComponent.printSubportionsLabels(
                    item.currentLaboratory.labId,
                    this.casId,
                    item.sampleId,
                    item.portionId,
                    [item]
                )
            }

            await this.loadCaseNode()
        }
    }

    async createIncidentToSubportion(): Promise<void> {
        if (this.state.selectedNodeForContextMenu?.text === AssaysViewTypeEnum.SUBPORTION) {
            const subportion = this.state.selectedNodeForContextMenu?.data as AssaysViewSubportionResponse
            await this._showIncidentFormModal(
                IncidentEntityType.SUBPORTION,
                this._getIncidentEntityIdHierarchy(subportion))
        }
    }
    async showSubportionIncidentsSidepanel(
        subportion: AssaysViewSubportionResponse,
        portion: AssaysViewPortionResponse,
        sample: AssaysViewSampleResponse
    ): Promise<void> {
        const response =
                await this.$_toCallUnique(
                    incidentServices.getSubportionsIncidents(
                        subportion.currentLaboratory.labId,
                        this.casId,
                        subportion.sampleId,
                        subportion.portionId,
                        subportion.subportionId))
        if (response) {
            this.state.incidents = response
            this.state.assayViewModalSidepanel = true
            this.state.isIncidentSidepanel = true
            this.state.isAttachmentSidepanel = false
            this.state.sidebarSample = sample
            this.state.sidebarPortion = portion
            this.state.sidebarSubportion = subportion
        }
    }

    async attachDocumentToSubportion(): Promise<void> {
        if (this.state.caseNode) {
            const subportion = this.state.selectedNodeForContextMenu?.data as AssaysViewSubportionResponse
            const subportionIdsArray = [
                subportion.currentLaboratory.labId,
                this.state.caseNode.data.casId,
                subportion.sampleId,
                subportion.portionId,
                subportion.subportionId
            ]
            await this._showAttachmentModal(AttachmentEntityType.SUBPORTION, subportionIdsArray)
        }
    }
    showSubportionAttachmentsSidepanel(
        subportion: AssaysViewSubportionResponse,
        portion: AssaysViewPortionResponse,
        sample: AssaysViewSampleResponse
    ): void {
        this.state.entitiesIdArray = [subportion.currentLaboratory.labId, this.casId, subportion.sampleId, subportion.portionId, subportion.subportionId]
        this.state.attachmentEntityType = AttachmentEntityType.SUBPORTION
        this.state.assayViewModalSidepanel = true
        this.state.isAttachmentSidepanel = true
        this.state.sidebarSample = sample
        this.state.sidebarPortion = portion
        this.state.sidebarSubportion = subportion
    }

    /**
     * Return the subportion count for a assay status code.
     * If the assay status code is not passed, returns the subportion count without filtering.
     * @param sampleId
     * @param assayStatusCode
     */
    getSubportionsCount(sampleId: number, assayStatusCode?: string): number {
        let total = 0
        this.state.portions.forEach(portion => {
            if (portion.subportions && sampleId === portion.sampleId) {
                total +=
                    portion.subportions.filter(
                        subportion => assayStatusCode ? subportion.assayStatus.code === assayStatusCode : true
                    ).length
            }
        })
        return total
    }
    getPortionsCount(sampleId: number): number {
        let total = 0
        this.state.portions.forEach(portion => {
            if (portion.portionTypeEnum !== PortionTypeEnum.VIRTUAL && portion.sampleId === sampleId) {
                total++
            }
        })
        return total
    }
    private static _getSubportionAssayStatusName(subportions: AssaysViewSubportionResponse[]): string {
        return subportions.length
            ? subportions[0].assayStatus.name
            : ''
    }
    getSubportionsProgressBarByAssayStatus(sampleId: number, assayStatusCode: string): string {
        let assayStatusName: string
        switch (assayStatusCode) {
        case 'PENDING':
            assayStatusName = AssaysViewModal._getSubportionAssayStatusName(this.state.subportionsPending)
            break
        case 'IN_PROCESS':
            assayStatusName = AssaysViewModal._getSubportionAssayStatusName(this.state.subportionsProgress)
            break
        case 'CANCELED':
            assayStatusName = AssaysViewModal._getSubportionAssayStatusName(this.state.subportionsCanceled)
            break
        case 'FINISHED':
            assayStatusName = AssaysViewModal._getSubportionAssayStatusName(this.state.subportionsCompleted)
            break
        default:
            return ''
        }
        const subportionsCount = this.getSubportionsCount(sampleId, assayStatusCode)
        return subportionsCount
            ? `${subportionsCount} ${assayStatusName}`
            : ''
    }

    /// SERVICE CALLS

    async loadCaseNode(): Promise<void> {
        const response =
            await this.$_toCallSecureLoading(
                assaysViewCaseService.getAssaysView(
                    this.labId,
                    this.casId))
        if (!response) {
            this.hide()
            return
        }

        this.state.selectedPortions = []
        this.state.selectedSubportions = []
        this.state.selectedSamples = []

        this.state.samples = response.samples
        this.state.portions = []
        this.state.subportions = []
        response.samples.forEach(sample => {
            this.state.portions.push(...sortBy(sample.portions, ['portionNumber']))

            sample.portions.forEach(portion => {
                this.state.subportions.push(...sortBy(portion.subportions, ['subportionNumber']))
            })
        })

        // set subportions by state
        this.state.subportionsCompleted = this.state.subportions.filter(
            subportion => subportion.assayStatus.code === ASSAY_STATES.FINISHED.code)
        this.state.subportionsProgress = this.state.subportions.filter(
            subportion => subportion.assayStatus.code === ASSAY_STATES.IN_PROCESS.code)
        this.state.subportionsPending = this.state.subportions.filter(
            subportion => subportion.assayStatus.code === ASSAY_STATES.PENDING.code)
        this.state.subportionsCanceled = this.state.subportions.filter(
            subportion => subportion.assayStatus.code === ASSAY_STATES.CANCELED.code)

        this.state.caseNode = {
            id: `${response.casId}`,
            text: AssaysViewTypeEnum.CASE,
            data: response,
            children: response.samples.map(sample => ({
                id: `${sample.samId}`,
                text: AssaysViewTypeEnum.SAMPLE,
                data: sample,
                children: sample.portions.map(portion => ({
                    id: `${portion.portionId}`,
                    text: AssaysViewTypeEnum.PORTION,
                    data: portion,
                    children: portion.subportions.map(subportion => ({
                        id: `${subportion.subportionId}`,
                        text: AssaysViewTypeEnum.SUBPORTION,
                        data: {
                            ...subportion,
                            metadata: {
                                ...subportion.metadata
                            }
                        }
                    }))
                }))
            }))
        }

        this.$nextTick(() => {
            if (this.tree) {
                const expandedNodes = this.tree.findAll<AssaysViewNode>({ state: { expanded: true } }) ?? []
                this.tree.setModel(this.state.caseNode?.children)
                if (expandedNodes.length) {
                    expandedNodes.forEach(
                        node => this.tree.find<AssaysViewNode>({ data: { label: node.data.label } })?.expand())
                }
            }
        })
    }

    private async _loadSubportionsCancellationReasons(): Promise<void> {
        const response = await this.$_toCallSecureLoading(
            cancellationReasonServices.getSubportionCancellationReasons())
        if (response) {
            this.state.cancellationReasonsForSubportions = response
        }
    }
    private async _loadPortionsCancellationReasons(): Promise<void> {
        const response = await this.$_toCallSecureLoading(
            cancellationReasonServices.getPortionCancellationReasons())
        if (response) {
            this.state.cancellationReasonsForPortions = response
        }
    }
    private async _loadPortionTypes(): Promise<void> {
        const response = await this.$_toCallSecureLoading(
            commonPortionTypeService.getPhysicalPortionTypes())
        if (response) {
            this.state.portionTypes = response
        }
    }

    private async _getDevices(laboratoryId: number, params?: CommonDeviceParams | undefined): Promise<CommonDeviceResponse[]> {
        const response = await this.$_toCallSecure(
            commonDeviceService.search(
                laboratoryId,
                params))
        return response ?? []
    }

    private async _getAssays(laboratoryIds: number[], searchText: string): Promise<AssayModalAssayWithValuableConceptResponse[]> {
        const response =
            await this.$_toCallSecure(
                assaysViewAssayService.searchAssays(this.labId, laboratoryIds, searchText))
        return response ?? []
    }

    updateAssaysLoadLaboratoryIdsIfNecessary(): void {
        this.$nextTick(() => this.$nextTick(() => {
            if (!this.visibleSubportionCreation || !this.visibleSubportionModification ||
            (!this.state.selectedPortions.length && !this.state.selectedSubportions.length)) {
                return
            }
            const currentSortedLaboratoryIdsBySelectedEntities =
                this._getCurrentLaboratoryIdsBySelectedEntities().sort((a, b) => (a - b))
            const hasLaboratoryIdsChanged = !this.areSortedArraysEqual(
                currentSortedLaboratoryIdsBySelectedEntities,
                this.state.assaysLoadLaboratoryIds
            )

            if (hasLaboratoryIdsChanged && !!currentSortedLaboratoryIdsBySelectedEntities.length) {
                this.state.assaysLoadLaboratoryIdsHasChanged = true
                this.state.assaysLoadLaboratoryIds = currentSortedLaboratoryIdsBySelectedEntities
            }
        }))
    }

    areSortedArraysEqual(array1: number[], array2: number[]): boolean {
        if (array1?.length !== array2?.length) {
            return false
        }
        for (let index = 0; index < array1.length; index++) {
            if (array1[index] !== array2[index]) {
                return false
            }
        }
        return true
    }

    async loadAssays(): Promise<AssayModalAssayWithValuableConceptResponse[]> {
        if (!this.state.assaysLoadLaboratoryIds.length) {
            return []
        }
        if (this.state.assaysLoadLaboratoryIdsHasChanged) {
            this.state.assays = await this._getAssays(this.state.assaysLoadLaboratoryIds, '')
            this.state.assaysLoadLaboratoryIdsHasChanged = false
        }
        return this.state.assays
    }

    async loadDevices(): Promise<void> {
        if (!this.state.selectedAssay) {
            return
        }

        this.state.devicesLoading = true
        try {
            this.state.devices = []

            const params = {
                operations: [
                    SubportionOperation.TO_STAINER,
                    SubportionOperation.STAIN,
                    SubportionOperation.STAIN_AND_COVER
                ],
                assayIds: [this.state.selectedAssay.id]
            }
            const labIds = this._getCurrentLaboratoryIdsBySelectedEntities()
            for (let i = 0; i < labIds.length; i++) {
                const devices = await this._getDevices(labIds[i], params)

                if (i === 0) {
                    this.state.devices = devices
                } else {
                    // TODO: backend should do the intersection (reduce logic in front)
                    this.state.devices = intersection(this.state.devices, devices)
                }
            }
        } finally {
            this.state.devicesLoading = false
        }
    }

    /// MODAL OPERATIONS

    async show(entitiesToFocus: LabeledEntity[]): Promise<void> {
        this.$_updateLoading(true)
        try {
            await Promise.all([
                this.loadCaseNode(),
                this._loadSubportionsCancellationReasons(),
                this._loadPortionsCancellationReasons(),
                this._loadPortionTypes(),
                assayState.loadStates()
            ])
        } finally {
            this.$_updateLoading(false)
        }

        this.state.assayViewModalSidepanel = false
        this.state.selectedPriority = this.priorityCas
        this.state.loaded = true

        this.assaysViewModal.show()
        this.$nextTick(() => this._openTreeByEntity(entitiesToFocus))
    }

    hide(): void {
        this.assaysViewModal.hide()
    }
    onHide(): void {
        this.state.caseNode = null

        this.state.samples = []
        this.state.portions = []
        this.state.subportions = []

        this.state.selectedDevice = null
        this.state.devices = []
        this.state.assaysLoadLaboratoryIds = []
        this.state.assays = []
    }
}
